import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import * as icons from "@material-ui/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { editCategory, uploadImage } from "../../Services/admin/Category";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useDispatch } from "react-redux";
import { TextField, Button, CircularProgress } from "@material-ui/core";
import swal from "sweetalert";
import { root } from "../../Services/config.json";

const CEdit = ({ history, location }) => {
  const dispatch = useDispatch();
  let { info } = location.state;
  const [e_title, setE_Title] = useState(info.e_title);
  const [f_title, setF_Title] = useState(info.f_title);
  const [p_title, setP_Title] = useState(info.p_title);
  const [b_color, setB_Color] = useState(info.b_color);
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState(`${root}${info.photo}`);
  const imgs = useRef();
  const [load, setLoad] = useState(false);
  let id = info.id;
  const handleE_title = (e) => {
    setE_Title(e.target.value);
  };
  const handleD_title = (e) => {
    setF_Title(e.target.value);
  };
  const handleP_title = (e) => {
    setP_Title(e.target.value);
  };
  const handleB_Color = (e) => {
    setB_Color(e.target.value);
  };
  useEffect(() => {
    console.log(url);
  }, [url]);

  const handleSave = async () => {
    if (e_title.length > 0 && f_title.length > 0 && p_title.length > 0) {
      try {
        dispatch(showLoading());
        await editCategory(id, {
          e_title,
          p_title,
          f_title,
          background: b_color,
        });
        if (image) {
          const fd = new FormData();
          fd.append("img", image, "jack");
          await uploadImage(id, fd);
        }
        swal("success!", "successfully category created!", "success");
        history.goBack();
      } catch (error) {
        let msg = "some error occured";
        let { status, data } = error.response;
        if (status == 400 || status == 401) {
          msg = data.msg;
        }

        swal("wrong!", msg, "error");
      } finally {
        dispatch(hideLoading());
      }
    } else {
      swal("wrong!", "please fill all field!", "error");
    }
  };
  const onInputChange = (e) => {
    // convert image file to base64 string
    const file = e.target.files[0];
    setImage(e.target.files[0]);
    const reader = new FileReader();
    reader.onload = (e) => {
      setUrl(e.target.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Container>
        <Row className="justify-content-center">
          <Col md="3" className="mt-2">
            <TextField
              size="small"
              fullWidth
              label="English name"
              value={e_title}
              onChange={handleE_title}
              variant="outlined"
            />
          </Col>
          <Col md="3" className="mt-2">
            <TextField
              size="small"
              fullWidth
              label="Dari name"
              value={f_title}
              onChange={handleD_title}
              variant="outlined"
            />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="3" className="mt-3">
            <TextField
              size="small"
              fullWidth
              label="Pashto name"
              value={p_title}
              onChange={handleP_title}
              variant="outlined"
            />
          </Col>
          <Col md="3" className="mt-3">
            <TextField
              size="small"
              fullWidth
              label="Background Color"
              value={b_color}
              onChange={handleB_Color}
              variant="outlined"
            />
          </Col>
        </Row>
        <Row className="justify-content-center mt-4">
          <Col md="6">
            <Row className="justify-content-start">
              <Col md="2">
                {load ? null : (
                  <div
                    style={{
                      width: 200,
                      backgroundColor: "white",
                      height: 200,
                    }}
                    className="text-center"
                  >
                    <CircularProgress style={{ marginTop: "80px" }} />
                  </div>
                )}
                <img
                  src={url}
                  onLoad={() => {
                    setLoad(true);
                  }}
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "contain",
                    display: load > 0 ? "block" : "none",
                  }}
                />
              </Col>
            </Row>
            <Row className="justify-content-start mt-3">
              <Col sm="5">
                <Button
                  fullWidth
                  onClick={() => {
                    imgs.current.click();
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Select new Image
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-center mt-4">
          <Col md="6">
            <Row className="justify-content-end">
              <Col md="2">
                <Button
                  fullWidth
                  onClick={handleSave}
                  variant="contained"
                  color="secondary"
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <input
          multiple
          type="file"
          accept="image/png, image/jpeg"
          onChange={onInputChange}
          style={{ display: "none" }}
          ref={imgs}
        />
      </Container>
    </>
  );
};

export default CEdit;
